import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicySummary = () => createSelector(substate, (contextState) => contextState.policySummary);
